"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToElementWithError = void 0;
const react_1 = require("react");
const use_scroll_to_element_1 = require("./use-scroll-to-element");
const useScrollToElementWithError = (submitCount, errors) => {
    const elementRefs = (0, react_1.useRef)({});
    const scrollToElement = (0, use_scroll_to_element_1.useScrollToElement)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const errorsInSmartComponent = Object.keys(errors);
        const [firstSmartComponentHasError] = errorsInSmartComponent;
        if (firstSmartComponentHasError) {
            scrollToElement(((_b = (_a = elementRefs.current) === null || _a === void 0 ? void 0 : _a[firstSmartComponentHasError]) === null || _b === void 0 ? void 0 : _b.offsetTop) || 0);
        }
    }, [submitCount, scrollToElement]);
    return elementRefs;
};
exports.useScrollToElementWithError = useScrollToElementWithError;
